export const isActiveLink = (link: NavigationLink, pathname: string) => {
  const startsWith = pathname.startsWith(link.url)
  // Make sure that every value in the beginning is the same
  const pathSplit = pathname.split("/")
  const sameFirstSplit = !link.url.split("/").filter((value, index) => {
    return value !== pathSplit[index]
  }).length
  return startsWith && sameFirstSplit
}
